import moment from "moment";
import { parsePayModDate, PayModDate } from "../services/planChange";

const localDay = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;

const utcWithoutZone = (instant: moment.Moment) =>
  instant.toISOString().slice(0, 19);

export const payModDay = (value: PayModDate | null | undefined) => {
  const parsed = parsePayModDate(value);
  return parsed.isValid() ? localDay(parsed.toDate()) : undefined;
};

export const paymentDateBounds = (from: string, to: string) => {
  const bounds: { payment_date_from?: string; payment_date_to?: string } = {};
  if (from) {
    bounds.payment_date_from = utcWithoutZone(moment(from).startOf("day"));
  }
  if (to) {
    bounds.payment_date_to = utcWithoutZone(moment(to).endOf("day"));
  }
  return bounds;
};

export const defaultPaymentDateRange = (
  range:
    | {
        earliest_payment?: PayModDate | null;
        latest_payment?: PayModDate | null;
      }
    | null
    | undefined,
  now = new Date()
) => {
  const earliest = payModDay(range?.earliest_payment);
  const to = payModDay(range?.latest_payment) || localDay(now);
  const firstOfMonth = localDay(moment(to).startOf("month").toDate());
  return {
    from: earliest && earliest > firstOfMonth ? earliest : firstOfMonth,
    to,
  };
};
